import { Component, OnInit } from '@angular/core';
import { ChartFacade } from '@mode/charts/contract';
import { ReportFilterFacade, ReportViewerFacade } from '@mode/report-viewer/domain';
import { ReportFacade } from '@mode/reports/domain';
import { DataViewFacade } from '@mode/switch-views/contract';
import { Observable, of } from 'rxjs';
import { filter, withLatestFrom } from 'rxjs/operators';

/* eslint-disable @angular-eslint/component-selector */
@Component({
  selector: 'mode-report-viewer',
  templateUrl: './report-viewer.component.html',
  styleUrls: ['./report-viewer.component.scss'],
})
export class ReportViewerComponent implements OnInit {
  reportReady$ = this.reportFacade.report$;
  reportGrid$ = this.reportFacade.layoutGridWithVizTokens$;
  allVizTokens: any[] = [];
  v2ChartCount$: Observable<any> = of(0);
  localSwitchViews$: Observable<any> = of(0);
  hasFilters$: Observable<boolean> = of(false);

  constructor(
    private reportFacade: ReportFacade,
    private chartFacade: ChartFacade,
    private reportViewerFacade: ReportViewerFacade,
    private reportFilterFacade: ReportFilterFacade,
    private dataViewFacade: DataViewFacade
  ) {}

  ngOnInit(): void {
    this.v2ChartCount$ = this.reportViewerFacade.v2ChartsInLayoutCount$;
    this.localSwitchViews$ = this.dataViewFacade.localSwitchViewCount$;
    this.hasFilters$ = this.reportFilterFacade.hasFilters$;

    // Hacky: loop through report grid and gets all viz tokens
    this.reportGrid$.pipe(filter((arr) => arr.length > 0)).subscribe((grid) => {
      if (grid[0]?.rows) {
        this.allVizTokens = grid[0].rows.map((row) => {
          return row?.columns[0]?.vizToken;
        });
      }
    });
  }

  renderEnd({ rendered, token }: any) {
    // We only want to call observability event for render end when ALL of the charts have loaded.
    // Remove loaded chart from tokens array
    const loadedTokenIndex = this.allVizTokens.indexOf(token);
    if (loadedTokenIndex !== -1) {
      this.allVizTokens.splice(loadedTokenIndex, 1);
    }
  }
}
